export const apiErrors = {
    INTERNAL_SERVER_ERROR : 500,
}